/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionTitle from '@components/Headings/SectionTitle';
import TopKolam from '@components/Headings/TopKolam';
import ProgramCard from '../components/Card/ProgramCard';

/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const PostProgram = ({ sectionContent, region, language }) => {
    // console.log("post program is", sectionContent)
    return (
        <Box marginTop={{ sm: "80px", base: "80px", lg: "100px" }}
            marginBottom={{ sm: "86px", base: "86px", lg: "86px" }}
        >
            {sectionContent.map((section, index) => {
                if (section?._modelApiKey === 'section_title') {
                    return (
                        <Box key={index} width={{base:"90%", sm:"90%", lg:"100%", md:"100%"}} margin={"auto"}>
                            <SectionTitle
                                titleObj={section}
                                titleDecoration="none"
                                color="#262626"
                                fontSize={{ base: "30px", sm: "30px", md: "" }}
                                lineHeight={{ base: "37px", sm: "37px", md: "" }}
                                // maxW={{ base: '280px', sm: '350px', md: '663px' }}
                                mx={{ base: '17px', md: 'auto' }}
                            />
                        </Box>
                    );
                }

                if (section?._modelApiKey === 'top_kolam') {
                    return (
                        <Box key={index} marginTop={"-30px"}>
                            <TopKolam
                                sectionContent={section}
                            />
                        </Box>
                    )
                }
                if (section?._modelApiKey === 'card_info4_column_group') {
                    return (
                        <Box key={index}
                            //marginTop={{ base: "60px", sm: "42px", md: "44px" }}
                            maxW={'1100PX'}
                            margin={'auto'} >
                         <ProgramCard
                                sectionContent={section}
                                region={region}
                                lang={language}
                            />
                        </Box>
                    )
                }
                if (section?._modelApiKey === 'simple_button') {
                    return (
                        <Box key={index}
                            marginTop={"60px"}
                            paddingBottom={{ sm: "80px", base: "80px", md: "120px" }}
                        >
                            <SimpleButton
                                style={section}
                                region={region}
                                lang={language}
                                mx="auto"
                            />
                        </Box>
                    )
                }
            })}
        </Box>
    );
};

export default PostProgram;
